import { type FormEvent } from 'react'

import { snapshot } from 'valtio'
import { toast } from 'react-toastify'
import { proxyNewUser, resetFormValues } from '../../../../shared/proxies/newUserProxy'
import { executeUpdateUser } from './executeUpdateUser'
import { executeDeleteUser } from './executeDeleteUser'
import { debouncedHandleFetch } from './NewUserForm/utils'
import { FormFieldNamesEnum } from './NewUserForm/formFieldNamesEnum'

export const closeDeleteModal = (): void => {
  proxyNewUser.displayUserDeleteModal = false
  resetFormValues()
}

export const closeEditModal = (): void => {
  proxyNewUser.displayUserEditModal = false
  resetFormValues()
}

export const closeAddModal = (): void => {
  proxyNewUser.displayUserAddModal = false
  resetFormValues()
}

export const handleDeleteSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
  const { deleteUserApiCall, selectedUser } = snapshot(proxyNewUser)
  e.preventDefault()

  if (!selectedUser) {
    return
  }

  await executeDeleteUser({ userId: selectedUser.id })

  if (deleteUserApiCall.error) {
    toast.error('Unable to delete User')
    return
  }

  toast.success('User deleted successfully')
  void debouncedHandleFetch()
  closeDeleteModal()
}

export const handleEditSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
  const { editUserApiCall, formValues, selectedUser } = snapshot(proxyNewUser)
  e.preventDefault()

  if (!selectedUser) {
    return
  }

  await executeUpdateUser({
    email: formValues[FormFieldNamesEnum.Email] as string,
    firstName: formValues[FormFieldNamesEnum.FirstName] as string,
    isAdmin: formValues[FormFieldNamesEnum.IsAdmin],
    lastName: formValues[FormFieldNamesEnum.LastName] as string,
    userId: String(selectedUser.id)
  })

  if (editUserApiCall.error) {
    toast.error('Unable to delete User')
    return
  }

  toast.success('User deleted successfully')
  void debouncedHandleFetch()
  closeEditModal()
}
